<template>
    <div :class="fixedTop ?'fixedTop':''">
      <pageHeader v-if="$route.name!='questionnaire'" />
      <router-view :key="routerViewKey" />
      <pageFooter v-if="$route.name!='questionnaire'" />
    </div>
</template>

<script>
  import pageHeader from '@/components/common/pageHeader2'
  import pageFooter from '@/components/common/pageFooter2'
  import router from '../router';
  export default {
    name: 'sd-layout-header-footer',
    components: {
      pageHeader,
      pageFooter,
    },
    data() {
      return {
        fixedTop: false,
        template: 2, // 头底模板类型
      }
    },
    watch: {
      $route(to, form) {

      }
    },
    computed: {
      routerViewKey() {
        // 默认情况下 key 类似 __transition-n-/foo
        // 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
        const stamp = this.$route.meta[`__stamp-${this.$route.path}`] || ''
        return `${stamp ? `__stamp-${stamp}-` : ''}${this.$route.path}`
      },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);

    },
    methods: {
      handleScroll() {
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        console.log(scrollTop,'scrollTopscrollTop');
        
        if (scrollTop > 130) {
          this.fixedTop = true;
        } else {
          this.fixedTop = false;
        }
      },
    }
  }
</script>

<style lang="less">
  .container {
    min-width: 1200px;
  }

  &.fixedTop {
    padding-top: 165px;

    .sd_header,
    .page_header,
    .page_header2 {
      position: fixed;
      top: 0px;
      left: 0px;
      box-shadow: 0px 0px 10px #9f9f9f;

      .header_top {
        display: none;
      }
    }
  }
</style>